<div class="page-layout blank p-24" fusePerfectScrollbar>
    <div class="">
        <h1>¡Bienvenido!</h1>
        <p class="lead">Signus Archivo</p>
    </div>

    <div *ngIf="!production">
        <h1>Estas en Modo desarrollo</h1>
        <button (click)="throwError()">Error</button>
        <button (click)="throwOtherError()">Other</button>
        <button (click)="throwHttpError()">HTTP</button>

        <br/>
        <br/>

        <strong *ngIf="sistema != null">Username: </strong> {{sistema.userName}}<br/>
        <strong *ngIf="sistema != null">ClientId: </strong> {{sistema.clientId}}<br/>
        
    </div>
        
</div>